export default __webpack_public_path__ + "static/media/reflecting.9cfab179.png";